
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
@Observer
@Component({
  components: {}
})
export default class PageView extends Vue {
  get Pagination() {
    return this.$store.$storeAbout.Pagination
  }
  get body() {
    return { columnId: '1' }
  }
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
